<template lang="pug">
.product-page
	.text-center.mb-3
		.main-title.mb-1.mb-lg-5 {{$t('ui.casino')}}
	.row
		.col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				a(href='javascript:void(0)' @click="launchLg()")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/casino/lg-casino.png')
						.product-hover
							img.w-100.img-fluid(src='img/casino/lg-casino-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
		//- 	.product-wrap
		//- 		a(href='#')
		//- 			.product-single
		//- 				.product-pic
		//- 					img.w-100.img-fluid(src='img/casino/bg-gaming.png')
		//- 				.product-hover
		//- 					img.w-100.img-fluid(src='img/casino/bg-gaming-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
		//- 	.product-wrap
		//- 		a(href='#')
		//- 			.product-single
		//- 				.product-pic
		//- 					img.w-100.img-fluid(src='img/casino/dream-gaming.png')
		//- 				.product-hover
		//- 					img.w-100.img-fluid(src='img/casino/dream-gaming-hover.png')
</template>
<script>
import config from '@/config'
export default {
	data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading: false,
      pageLoading:false,
			isMobile: false
    }
  },
	computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "mm"
    },
  },
	mounted(){
		if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			this.isMobile = true
		}else{
			this.isMobile = false
		}
	},
	methods:{
		launchLg(){
			if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let lang_code = "en"
				let mobile = this.isMobile
        this.$store
          .dispatch("user/launchLg", { player_id, auth_token, mobile, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							}) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				$('#modal-login').modal('show')
			}
		}
	}
}
</script>